import { ReactNode, useEffect, useState } from "react";
import { IntlProvider as ReactIntlProvider } from "react-intl";
import { adjustKeys, loadMessages } from "@/lib/i18n-config";
import { detectLocale } from "@/lib/locale-detection";
import { useProfileLocaleSync } from "@/hooks/useProfileLocaleSync";

export function IntlProvider({ children }: { children: ReactNode }) {
    const [locale, setLocale] = useState(() => {
        // Detect locale on mount
        if (typeof window !== "undefined") {
            return detectLocale();
        }
        return "en";
    });

    useProfileLocaleSync(locale);

    const [messages, setMessages] = useState<Record<string, any>>(() => {
        const rawMessages = loadMessages(locale);
        return adjustKeys(rawMessages);
    });

    useEffect(() => {
        // Update HTML attributes when locale changes
        const html = document.documentElement;
        html.lang = locale;
        html.dir = locale === "he" ? "rtl" : "ltr";

        // Load new messages
        const rawMessages = loadMessages(locale);
        setMessages(adjustKeys(rawMessages));
    }, [locale]);

    function onError() {
        // Suppress missing translation errors for English
        // For English, it's not absolutely required to have translations defined
    }

    return (
        <ReactIntlProvider locale={locale} messages={messages} onError={onError}>
            {children}
        </ReactIntlProvider>
    );
}
